module.exports = __webpack_public_path__ + "img/logo.cd0adf0d.svg";